export default __webpack_public_path__ + "static/media/adv-lucas.a0ca2ed5.png";